var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDowninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "4781840_+_add_circle_create_expand_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rect\\xE1ngulo 289",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.185 12.108l-5.13 5.13-5.13-5.13a1.325 1.325 0 10-1.874 1.875l5.71 5.71a1.72 1.72 0 002.589 0l5.708-5.71a1.325 1.325 0 10-1.874-1.874z",
    fill: "#00706a",
    fillRule: "evenodd"
  })));
}

export default SvgChevronDowninline;